/**
 * Em-dash glyph (U+2014) used as the standard "no data" placeholder across
 * load-specific rows in the Shipment Details flyout.
 */
export const EM_DASH = "\u2014";

/**
 * Returns the trimmed input when it contains visible characters, otherwise
 * returns an em dash. Used by load-specific rows in both the LTL stop section
 * and the non-LTL unified card to render `—` for null/undefined/empty/
 * whitespace-only values per the load-specific null-handling ground rule
 */
export function emDashIfBlank(value: string | null | undefined): string {
	if (value == null) {
		return EM_DASH;
	}
	const trimmed = value.trim();
	return trimmed.length === 0 ? EM_DASH : trimmed;
}
